const n = (t, o) => t < 0 ? o + t : t, E = (t, o) => ({
  id: t,
  element: o
});
const F = (t, o, s) => o - (t + s) < 1.5, O = (t) => t < 1.5;
export {
  F as isAtBottom,
  O as isAtTop,
  n as normalizeNegativeIndex,
  E as toItem
};
